import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableListCauseriePage = withAsyncLoading(async () =>
    import('./ListCauseriePage').then((res) => res.ListCauseriePage)
);

export { LoadableListCauseriePage };
